import PropType from 'prop-types';

import React, { createContext, useContext, useReducer, useState } from 'react';

import { APP_STATE } from '../constants/app_state';
import NewsLetterModal from '../sections/newsletters/NewsLetterModal';
import { Fab, Stack } from '@mui/material';
import { Icon } from '@iconify/react';
import { ChatWindow } from '../sections/chat';

const WelcomMessage =
  'Bienvenue sur le site de l’API-ZF. Je peux vous orienter vers les investissements, les régimes, les procédures ou les contacts utiles.';

const HelpMessage = [
  {
    text: 'Investir au Togo',
    children: [
      { text: "Guide de l'investisseur", url: '/investir-au-togo/le-guide-d-investisseur' },
      { text: 'Profils sectoriels', url: '/investir-au-togo/profil-secteur' },
    ],
  },
  {
    text: 'Choisir un régime',
    children: [
      {
        text: 'Zone franche',
        children: [
          { text: "Vérifier l'éligibilité", url: '/zone-franche/conditions-deligibilite' },
          { text: 'Comprendre les avantages', url: '/zone-franche/avantages-accordes' },
          { text: "Préparer l'agrément", url: '/zone-franche/procedure-d-obtention-d-agrement' },
        ],
      },
      {
        text: 'Code des investissements',
        children: [
          { text: "Vérifier l'éligibilité", url: '/code-des-investisseurs/conditions-d-iligibilite' },
          { text: 'Comprendre les avantages', url: '/code-des-investisseurs/avantages-accordes' },
          { text: "Préparer l'agrément", url: '/code-des-investisseurs/procedure-d-obtention-d-agrement' },
        ],
      },
    ],
  },
  {
    text: 'Démarrer une procédure',
    children: [
      { text: 'Agrément Zone franche', url: '/zone-franche/procedure-d-obtention-d-agrement' },
      {
        text: 'Agrément Code des investissements',
        url: '/code-des-investisseurs/procedure-d-obtention-d-agrement',
      },
    ],
  },
  {
    text: "Contacter l'API-ZF",
    children: [
      {
        text: 'API-ZF',
        children: [
          { text: 'Contact direct', note: 'Appelez lʼAPI-ZF : +228 22 53 53 53 / WhatsApp : +228 90 28 33 32' },
          { text: 'Prendre un rendez-vous', url: '/contact-us' },
        ],
      },
      { text: 'Autres', children: [{ text: 'Annuaires Togo', url: 'http://www.annuairestogo.tg/', url_type: 'ext' }] },
    ],
  },
];

const convesationDefault = [
  {
    text: WelcomMessage,
    isLeft: true,
    onClick: false,
  },
  ...HelpMessage,
];

const initialState = {
  subMenu: [],
  conversations: convesationDefault,
};

const AppProvider = createContext({
  ...initialState,
  handleClose: () => {},
  handleOpen: () => {},
  // eslint-disable-next-line no-unused-vars
  appdispatch: ({ type, payload }) => {},
});

AppContext.propTypes = {
  children: PropType.node,
};

const reducer = (state, action) => {
  switch (action.type) {
    case APP_STATE.subMenu:
      return { ...state, subMenu: action.payload };
    case APP_STATE.conversation_init:
      return { ...state, conversations: [...convesationDefault] };
    case APP_STATE.convesation_bulle_link:
      return { ...state, conversations: [...state.conversations, action.payload] };
    case APP_STATE.convesation_bulle_note:
      return { ...state, conversations: [...state.conversations, action.payload] };
    case APP_STATE.convesation_bulle_children:
      return { ...state, conversations: [...state.conversations, ...action.payload] };
    case APP_STATE.convesation_back: {
      let conv = state.conversations;
      if (conv.length > convesationDefault.length) {
        conv.pop();
      }
      return { ...state, conversations: conv };
    }

    default:
      return { ...state };
  }
};

export const useAppContext = () => useContext(AppProvider);

export default function AppContext({ children }) {
  const [state, appdispatch] = useReducer(reducer, initialState);
  const [open, setOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClickChat = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseChat = () => {
    setAnchorEl(null);
  };

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  return (
    <AppProvider.Provider value={{ ...state, appdispatch, handleOpen, handleClose }}>
      {children}
      <NewsLetterModal onClose={handleClose} open={open} />
      <Stack
        position="fixed"
        bottom={50}
        right={30}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <Fab color="primary" variant={hover ? 'extended' : 'circular'} onClick={handleClickChat}>
          {hover && 'Chat '} {hover && <span style={{ paddingLeft: 10 }} />}
          <Icon icon="mdi:chat" height={25} width={25} />
        </Fab>
      </Stack>
      <ChatWindow onClose={handleCloseChat} anchorEl={anchorEl} />
    </AppProvider.Provider>
  );
}
